import { useState } from "react";
import { useSelector } from "react-redux";
import AddBundles from "../../component/places/modal/AddBundles";
import SearchComponent from "../../component/search/SearchComponent";
import BundleListRow from "../../component/tours/BundleListRow";

const Bundles = () => {
  const [filterData, setFilterData] = useState<any>();
  const [searchValue, setSearchValue] = useState();
  const bundles = useSelector((state: any) => state.getBundles);

  const getSearchData = (data: any, value: any) => {
    setSearchValue(value);
    setFilterData(data);
  };
  const { adminPermission } = useSelector((state: any) => state.counter);

  if (adminPermission?.is_admin == 2 && !adminPermission?.bundels) {
    return (
      <h1 className="text-3xl font-openSans font-bold text-aqua items-center flex justify-center h-[80vh]">
        You don't have permission
      </h1>
    );
  }

  const list: any[] =
    (filterData?.length || searchValue
      ? filterData
      : bundles.Bundles?.data?.data) || [];

  return (
    <div>
      <div className="flex justify-between px-12">
        <SearchComponent
          getSearchData={getSearchData}
          data={bundles.Bundles?.data?.data}
        />
        <div className="flex">
          <AddBundles />
        </div>
      </div>

      {!filterData?.length && searchValue ? (
        <h2 className="mt-4 text-center">
          <span className="text-xl text-red-600">{searchValue}</span> is not
          available
        </h2>
      ) : null}

      <div className="mx-14 mt-9 mb-6 bg-white border border-gray-200 rounded-2xl overflow-hidden">
        {/* Header */}
        <div className="grid grid-cols-[60px_minmax(0,2.5fr)_100px_minmax(0,1.2fr)_100px] gap-4 items-center px-6 py-3 bg-gray-50 border-b border-gray-200 text-xs font-semibold text-gray-500 uppercase tracking-wide">
          <div></div>
          <div>Bundle</div>
          <div>Tours</div>
          <div>Price</div>
          <div className="text-right">Actions</div>
        </div>

        {/* Rows */}
        {list.length ? (
          list.map((elm: any) => (
            <BundleListRow key={elm?.id} bundle={elm} />
          ))
        ) : (
          <div className="px-6 py-12 text-center text-gray-400 text-sm">
            No bundles yet
          </div>
        )}
      </div>
    </div>
  );
};

export default Bundles;
